export * from "./QuizMCQMultiAnswer";
